module.exports = __webpack_public_path__ + "fonts/8cac70ebda3f23ce472110d9f21e8593.woff";